import React from 'react';

function AdhesionAlDebito() {
    // Función para manejar las descargas
    const descargarPlanilla = (archivo) => {
        // Crear un enlace temporal para descargar el archivo
        const enlace = document.createElement('a');
        enlace.href = archivo;
        enlace.download = archivo.split('/').pop(); // Obtener el nombre del archivo desde la URL
        enlace.click();
    };

    return (
        <div className="max-w-4xl mx-auto p-6 bg-gradient-to-br from-green-800 to-green-600 text-center text-white rounded-lg shadow-lg">
             

            {/* Subtítulo */}
            <h2 className="text-2xl font-semibold mb-6">Planillas Débito</h2>

            {/* Botón para descargar la planilla */}
            <button 
                onClick={() => descargarPlanilla('./assets/planillas/AUTORIZACION Debito.pdf')}
                className="px-8 py-4 bg-green-500 text-black font-semibold rounded-lg transition-all transform hover:scale-105 hover:bg-green-600 shadow-md mb-4"
            >
                Descargar Autorización Adhesión Débito
            </button>

            {/* Información adicional */}
            <p className="text-lg font-light mt-4">Imprimir y traer a administración</p>
            <p className="text-lg font-light">Santiago del Estero 666</p>

            {/* Espaciado para mayor separación */}
            <div className="space-y-6">
                {/* Sección adicional o vacía si no se necesita contenido */}
            </div>
        </div>
    );
}

export default AdhesionAlDebito;

